import { Box, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { RevealView, StaggerItemView, StaggerView } from '../../common/motion';
import { resolveIntroBrokerName } from '../utils';
import IntroResourceRow from './IntroResourceRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroResourcesSection = function IntroResourcesSection() {
  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;
  /**
   * watch
   */


  var _useFormContext = useFormContext(),
      control = _useFormContext.control;

  var brokerName = useWatch({
    control: control,
    name: 'brokerName'
  });
  var resourcesTitle = useWatch({
    control: control,
    name: 'resourcesTitle'
  });
  var resourcesSubtitle = useWatch({
    control: control,
    name: 'resourcesSubtitle'
  });
  var resourceItems = useWatch({
    control: control,
    name: 'resourceItems'
  });

  var renderHeaderCell = function renderHeaderCell(label, className) {
    return /*#__PURE__*/_jsx(Box, {
      className: "flex flex-row items-center space-x-1.5 ".concat(className || ''),
      children: /*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-bold text-white",
        children: label
      })
    });
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col items-center space-y-12 py-16 md:py-24",
    children: [/*#__PURE__*/_jsxs(RevealView, {
      className: "flex flex-col items-center space-y-4 text-center",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "font-['Playfair_Display',serif] text-3xl font-bold leading-tight text-[#202020] md:text-[44px]",
        children: resolveIntroBrokerName(resourcesTitle, brokerName)
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-base leading-7 text-[#474747] md:text-lg",
        children: resourcesSubtitle
      })]
    }), /*#__PURE__*/_jsx(RevealView, {
      className: "w-full",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex w-full flex-col space-y-3",
        children: [/*#__PURE__*/_jsxs(Box, {
          className: "grid grid-cols-[1fr_auto] items-center gap-x-4 rounded-xl bg-[#006DB0] px-6 py-4 md:grid-cols-[1fr_120px] md:px-8",
          children: [renderHeaderCell($t('page:subBrokerPortal.description')), renderHeaderCell($t('page:subBrokerPortal.download'), 'hidden md:flex md:justify-center')]
        }), /*#__PURE__*/_jsx(StaggerView, {
          className: "flex flex-col space-y-3",
          stagger: 0.08,
          children: resourceItems.map(function (item) {
            return /*#__PURE__*/_jsx(StaggerItemView, {
              distance: 16,
              children: /*#__PURE__*/_jsx(IntroResourceRow, {
                item: item
              })
            }, item.title);
          })
        })]
      })
    })]
  });
};

export default IntroResourcesSection;